import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button) => {
      return (_openBlock(), _createBlock(_component_ButtonComponent, {
        key: button.label,
        onButtonClicked: _ctx.buttonClicked,
        button: button,
        theme: _ctx.selectButtonTheme(button.action),
        disabled: _ctx.isDisabled
      }, null, 8, ["onButtonClicked", "button", "theme", "disabled"]))
    }), 128))
  ]))
}